export const buildPriceMessagePartOne = [
  `You can lock in this build price on Lot {lot} by completing a`,
];

export const buildPriceMessagePartTwo =
  ". This will guarantee your build price for 30 days while you do your due diligence.";

export const changeRequestMessageParts = [
  "Want to add a few finishing touches to make it your own? Tell us what you’re looking for and we’ll get back to you with an updated build quote.",
];
